import { render, staticRenderFns } from "./orderDocument.vue?vue&type=template&id=3ce2b8ce&"
import script from "./orderDocument.vue?vue&type=script&lang=js&"
export * from "./orderDocument.vue?vue&type=script&lang=js&"
import style0 from "./orderDocument.vue?vue&type=style&index=0&id=3ce2b8ce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports